import React, { useEffect } from "react";
import { HeaderSocialProps } from "./HeaderSocial.types";
import { HeaderSocialContainer } from "./HeaderSocial.style";
import { ComponentMapping, Container } from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

const useScrollToAnchor = () => {
  useEffect(() => {
    const scrollToAnchor = () => {
      const hash = window.location.hash;
      if (hash) {
        let elements = document.querySelectorAll(hash) as NodeListOf<HTMLElement>;
        let elementsArray = Array.from(elements);

        if (elementsArray.length === 0) {
          console.warn("⚠️ Nenhum elemento encontrado no DOM para:", hash);
          return;
        }

        let selectedElement: HTMLElement | null = null;
        const screenWidth = window.innerWidth;
        const isMobile = screenWidth <= 768;
        const isTablet = screenWidth > 768 && screenWidth <= 1024;
        const isDesktop = screenWidth > 1024;

        let visibleElements = elementsArray.filter((element) => {
          const parentElement = element.closest(".aem-GridColumn");
          if (!parentElement) return false;

          const isDesktopElement = parentElement.classList.contains("aem-GridColumn--default--none");
          const isTabletElement = parentElement.classList.contains("aem-GridColumn--tablet--none");
          const isMobileElement = parentElement.classList.contains("aem-GridColumn--phone--none");

          return (isMobile && isMobileElement) || (isTablet && isTabletElement) || (isDesktop && isDesktopElement);
        });

        if (visibleElements.length > 0) {
          selectedElement = visibleElements[0];
        }

        if (selectedElement) {
          let attempts = 0;
          const waitForElement = () => {
            if (attempts >= 15) {
              console.warn("⚠️ O elemento não ficou visível após 3 segundos!", selectedElement);
              return;
            }

            const rect = selectedElement?.getBoundingClientRect();
            if (rect && rect.height > 0) {
              forceScroll(selectedElement);
            } else {
              attempts++;
              setTimeout(waitForElement, 200);
            }
          };

          waitForElement();
        } else {
          console.warn("⚠️ Nenhum elemento correto selecionado para a âncora:", hash);
        }
      }
    };

    scrollToAnchor();
    window.addEventListener("hashchange", scrollToAnchor);

    return () => {
      window.removeEventListener("hashchange", scrollToAnchor);
    };
  }, []);
};

const forceScroll = (element: HTMLElement) => {
  element.scrollIntoView({ behavior: "smooth"});

  setTimeout(() => {
    const rect = element.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight) {
      window.scrollTo({
        top: window.scrollY + rect.top - 100,
        behavior: "smooth",
      });
    }
  }, 300);
};

export default class HeaderSocial extends Container<HeaderSocialProps, CoreContainerState> {
  targetRef: React.RefObject<HTMLDivElement>;

  constructor(props: HeaderSocialProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };

    this.targetRef = React.createRef();

  }

  componentDidMount() {
    this.targetLink();
  }

  componentDidUpdate(_prevProps: HeaderSocialProps) {
    this.targetLink();
  }

  targetLink = () => {
    const clickTarget = this.targetRef.current?.querySelector('.cmp-image__link');
    const header = document.querySelector('#header div:nth-child(3)');

    const targetImage = this.targetRef.current?.querySelector('img[alt="WhatsApp Icon"]') as HTMLImageElement | null;

    if (clickTarget && header && targetImage) {
      clickTarget.setAttribute("target", "_blank");
    } else {
      clickTarget?.removeAttribute("target");
    }
  };

  render() {
    const { backgroundColor } = this.props;
    return (
      <>
        <HeaderSocialContainer $backgroundcolor={backgroundColor}>
          <div className="header-social" ref={this.targetRef}>
            {this.childComponents &&
              this.childComponents.map((item, k) => {
                if (k < 1) {
                  return (
                    <div key={k} className="social__item">
                      {item}
                    </div>
                  );
                }
                return null;
              })}
          </div>
        </HeaderSocialContainer>
        {this.childComponents.length < 1 && this.placeholderComponent}

      </>
    );
  }
}
export const HeaderSocialWrapper: React.FC<HeaderSocialProps> = (props) => {
  useScrollToAnchor();
  return <HeaderSocial {...props} />;
};




